export default () => import('./RichTextEmailEditor.vue');
